
<template>
<b-row>
    <BarChart v-if="loaded" css-classes="col-12 col-sm-12 col-md-6 col-xl-4 pb-4" barcolor="#007d8f" :barlabel="thisYear +' Number of surveys per month '" :labels="labels" :chartdata="chartdata" />
    <BarChart v-if="qloaded" css-classes="col-12 col-sm-12 col-md-6 col-xl-4 pb-4" :barlabel="thisYear + ' Number of questionnaires per month'" :labels="qlabels" :chartdata="qchartdata" />
    <BarChart v-if="cloaded" css-classes="col-12 col-sm-12 col-md-6 col-xl-4 pb-4" barcolor="#007d8f" :barlabel="thisYear + 'Top consultants by number of questionnaires '" :labels="clabels" :chartdata="cchartdata" />
</b-row> 
</template>

<script>
import axios from 'axios'
import BarChart from './CustomControls/BarChart'
import { config } from '../../config';
const base_url = config.base_url;
const api_token = config.api_token;

export default {
  name: 'Statistics',
  components: {
    BarChart
  },
  created() {
    this.statistics_get();
    this.questionnaires_get();
    this.topconsultants_get();   
  },
  data: function() {
    return {
      loaded: false,
      labels: ['10'],
      chartdata: [10,20],
      qloaded: false,
      qlabels: ['10'],
      qchartdata: [10,20], 
      cloaded: false,
      clabels: ['10'],
      cchartdata: [10,20],
      thisYear: '',      
    }
  },
  methods: {
    statistics_get() {
      this.thisYear = new Date().getFullYear().toString();
      let labels = [];
      let chartdata = [];
      const url = base_url+"/gdq_stats_surveyspermonth";
      axios.defaults.headers.common['Authorization'] = 'Bearer:'+api_token;
      axios.get(
        url,
        {
          headers: {
            "Accept": "application/json",
            "Content-type": "application/json",
          }
        }
      )
      .then((resp) => {
        this.labels = [];
        this.chartdata = [];
        resp.data.map( r => {
          labels.push(r.month_year);
          chartdata.push(r.numbersurveys);
        });
        this.labels = labels;
        this.chartdata = chartdata;
        this.loaded = true;
      })
    },
    questionnaires_get() {
      let qlabels = [];
      let qchartdata = [];
      const url = base_url+"/gdq_stats_questionnairespermonth";
      axios.defaults.headers.common['Authorization'] = 'Bearer:'+api_token;
      axios.get(
        url,
        {
          headers: {
            "Accept": "application/json",
            "Content-type": "application/json",
          }
        }
      )
      .then((resp) => {
        this.qlabels = [];
        this.qchartdata = [];
        resp.data.map( r => {
          qlabels.push(r.month_year);
          qchartdata.push(r.numberquestionnaires);
        });
        this.qlabels = qlabels;
        this.qchartdata = qchartdata;
        this.qloaded = true;
      })
    },
    topconsultants_get() {
      let clabels = [];
      let cchartdata = [];
      const url = base_url+"/gdq_stats_topconsultantsyear";
      axios.defaults.headers.common['Authorization'] = 'Bearer:'+api_token;
      axios.get(
        url,
        {
          headers: {
            "Accept": "application/json",
            "Content-type": "application/json",
          }
        }
      )
      .then((resp) => {
        this.clabels = [];
        this.cchartdata = [];
        resp.data.map( r => {
          clabels.push(r.consultant);
          cchartdata.push(r.numberquestionnaires);
        });
        this.clabels = clabels;
        this.cchartdata = cchartdata;
        this.cloaded = true;
      })
    },    
  },
}
</script>
<style scoped>
</style>